import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    disabled;
    confidence;
    type;
    ruleForm = {
        confidenceValue: this.$props.confidence,
    };
    get rules() {
        return {
            confidenceValue: [{ pattern: this.getPattern(), message: this.inputPlaceholder, trigger: 'blur' }],
        };
    }
    getPattern() {
        let reg = /^(http|https):\/\/[\w\-_\u4E00-\u9FA5:/]+(\.[\w\-_\u4E00-\u9FA5]+)+([\u4E00-\u9FA5\w\-.,@?^=%&:/~+#]*[\u4E00-\u9FA5\w\-@?^=%&/~+#])?$/;
        return reg;
    }
    get inputPlaceholder() {
        // if (this.type === 'vehicleNumber') {
        //   return this.$t('vehicleInputRule');
        // } else {
        return this.$t('thresholdInputRule');
        // }
    }
    changeName(val) {
        this.$emit('update:confidence', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
};
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop()
], default_1.prototype, "confidence", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
default_1 = __decorate([
    Component({
        name: 'httpConfidence',
        components: {},
        i18n: {
            messages: {
                zh: {
                    thresholdInputRule: '请输入正确的url地址',
                    placeholderUrl: '请输入url',
                },
                en: {
                    thresholdInputRule: 'Please enter the correct URL address',
                    placeholderUrl: 'Please enter the url',
                },
            },
        },
    })
], default_1);
export default default_1;
